import {useMemo, useRef} from 'react';
import {ViewportProvider, ViewportState, useApplication} from '../../contexts';
import {
  usePreviewSettings,
  useSharedSettings,
  useSize,
} from '../../hooks';
import {RemotionPreview} from '../../remotion/RemotionPreview';
import type {RemotionPlayerAdapter} from '../../remotion/RemotionPlayerAdapter';
import styles from './Viewport.module.scss';

export function EditorPreview() {
  const {player} = useApplication();
  const containerRef = useRef<HTMLDivElement>();
  const size = useSize(containerRef);
  const settings = {
    ...useSharedSettings(),
    ...usePreviewSettings(),
  };

  const adapter = player as RemotionPlayerAdapter;
  const sceneWrappers = adapter.sceneWrappers;
  const hasScenes = sceneWrappers && sceneWrappers.length > 0;

  const state: ViewportState = useMemo(() => {
    const {width, height} = settings.size;
    let zoom = size.height / height;
    if (width * zoom > size.width) {
      zoom = size.width / width;
    }
    if (isNaN(zoom) || zoom <= 0 || !isFinite(zoom)) {
      zoom = 1;
    }

    return {
      grid: false,
      rect: size,
      x: 0,
      y: 0,
      zoom,
      resolutionScale: settings.resolutionScale,
    };
  }, [settings, size]);

  return (
    <ViewportProvider value={state}>
      <div className={styles.viewport} ref={containerRef}>
        {hasScenes ? (
          <RemotionPreview
            scenes={sceneWrappers}
            adapter={adapter}
          />
        ) : (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              height: '100%',
              color: 'rgba(255,255,255,0.3)',
              fontSize: 14,
            }}
          >
            No scenes loaded
          </div>
        )}
      </div>
    </ViewportProvider>
  );
}
